import { UserMessageTextMention } from './UserMessageTextMention.jsx'
import { UserMessageTextPlain } from './UserMessageTextPlain.jsx'

export default function UserMessageTextView(props) {
  const { text, emojiOnly, hasMention, mentionSegments, mentionLookup, hasMentionRoster, textClassName, hasEmoji } =
    props

  if (emojiOnly) return <p className={textClassName}>{text}</p>
  if (!hasMention) return <UserMessageTextPlain text={text} textClassName={textClassName} withEmoji={hasEmoji} />
  return (
    <UserMessageTextMention
      mentionSegments={mentionSegments}
      mentionLookup={mentionLookup}
      hasMentionRoster={hasMentionRoster}
      textClassName={textClassName}
    />
  )
}
